/* loaded by smart-asset */
export default require("./assets/confirmation.mp3")